import { render } from "./StatementDetails.vue?vue&type=template&id=00dcba34&scoped=true"
import script from "./StatementDetails.vue?vue&type=script&lang=js"
export * from "./StatementDetails.vue?vue&type=script&lang=js"

import "./StatementDetails.vue?vue&type=style&index=0&id=00dcba34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00dcba34"

export default script